import React, { useState, useEffect } from 'react';
import { applyUpdate } from '../serviceWorkerUpdates';
import './UpdateBanner.css';

const UpdateBanner = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const handler = () => setUpdateAvailable(true);
    window.addEventListener('swUpdateAvailable', handler);
    return () => window.removeEventListener('swUpdateAvailable', handler);
  }, []);

  if (!updateAvailable) return null;

  return (
    <div className="update-banner">
      <span>New version available</span>
      <button className="update-banner-btn" onClick={() => applyUpdate()}>
        Tap to update
      </button>
    </div>
  );
};

export default UpdateBanner;
